import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import IconButton from "../../../../packages/IconButton";

import { KEYBOARD_KEYS } from "../../../../constants/global.constants";

import { RemoveIcon, SearchIcon } from "../../../../assets/icons";

import SearchInputBox from "../../../../common/styles/components/inputs/SearchInputBox";

const LicenseSearchFilter = ({ updateLicensePayload, currentSearch = "" }) => {
  const { t } = useTranslation();
  const [licenseSearchState, setLicenseSearchState] = useState({
    inputValue: currentSearch,
    activeFilter: currentSearch,
  });

  useEffect(() => {
    if (currentSearch === "" && licenseSearchState.activeFilter !== "") {
      setLicenseSearchState({
        inputValue: "",
        activeFilter: "",
      });
    }
  }, [currentSearch]);

  const handleSearchChange = (e) => {
    setLicenseSearchState((prev) => ({
      ...prev,
      inputValue: e.target.value,
    }));
  };

  const clearFilter = useCallback(() => {
    updateLicensePayload({ searchstr: "", pageNumber: 1 });
    setLicenseSearchState((prev) => ({
      ...prev,
      activeFilter: "",
    }));
  }, [updateLicensePayload]);

  const handleSearchSubmit = useCallback(() => {
    const sanitizedSearchTerm = licenseSearchState.inputValue.trim();
    if (!sanitizedSearchTerm && licenseSearchState.activeFilter) {
      clearFilter();
      return;
    }

    if (
      sanitizedSearchTerm &&
      sanitizedSearchTerm !== licenseSearchState.activeFilter
    ) {
      updateLicensePayload({ searchstr: sanitizedSearchTerm, pageNumber: 1 });
      setLicenseSearchState((prev) => ({
        ...prev,
        activeFilter: sanitizedSearchTerm,
      }));
    }
  }, [
    licenseSearchState.inputValue,
    licenseSearchState.activeFilter,
    updateLicensePayload,
    clearFilter,
  ]);

  const handleClearSearch = useCallback(() => {
    setLicenseSearchState((prev) => ({
      ...prev,
      inputValue: "",
    }));
    if (licenseSearchState.activeFilter) {
      clearFilter();
    }
  }, [licenseSearchState.activeFilter, clearFilter]);

  const handleSearchBlur = useCallback(() => {
    if (
      licenseSearchState.activeFilter &&
      !licenseSearchState.inputValue.trim()
    ) {
      setLicenseSearchState((prev) => ({
        ...prev,
        inputValue: "",
      }));
      clearFilter();
    }
  }, [
    licenseSearchState.activeFilter,
    licenseSearchState.inputValue,
    clearFilter,
  ]);

  const handleKeyDown = (event) => {
    if (event.key === KEYBOARD_KEYS.ENTER) {
      handleSearchSubmit();
    }
  };

  const clearButtonElement = licenseSearchState.inputValue ? (
    <IconButton id="license-search-clear-icon" onClick={handleClearSearch}>
      <RemoveIcon className="clear-search-icon" />
    </IconButton>
  ) : (
    ""
  );

  return (
    <div className="license-search-filter">
      <SearchInputBox
        id="license-search-input"
        name="license-search-input"
        value={licenseSearchState.inputValue}
        onChange={handleSearchChange}
        onSearch={handleSearchSubmit}
        onBlur={handleSearchBlur}
        onKeyDown={handleKeyDown}
        placeholder={t("licenseManagement.searchPlaceholder")}
        icon={<SearchIcon className="filter-search-icon" />}
        inputText={clearButtonElement}
        unitBgColor="transparent"
      />
    </div>
  );
};

export default LicenseSearchFilter;
